var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee" },
    [
      _vm.overviewFees
        ? _vm._l(_vm.overviewFees, function(assetFees, asset) {
            return _c("div", { key: asset, staticClass: "fee__asset-info" }, [
              _c("div", { staticClass: "container-header" }, [
                _c("div", { staticClass: "container-header__title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.i18n.fees_your_fees({ asset: _vm.feesNames[asset] })
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container container_40" },
                [
                  _c(
                    "md-table",
                    { staticClass: "scrollbar" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.i18n.fees_fee_type()))
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.i18n.fees_subtype()))
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.i18n.fees_fixed()))
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.i18n.fees_percent()))
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.i18n.fees_lower_bound()))
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.i18n.fees_upper_bound()))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(assetFees, function(fee, i) {
                        return [
                          _c(
                            "md-table-row",
                            { key: i },
                            [
                              _c(
                                "md-table-cell",
                                { staticClass: "fee-table__type text_large" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("localizeFeeType")(fee.fee_type)
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                {
                                  staticClass: "fee-table__subtype text_medium"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("localizeSubtype")(fee.subtype)
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "fee-table__value text_medium" },
                                [
                                  _vm._v(_vm._s(_vm.i18n.c(fee.fixed)) + " "),
                                  _c(
                                    "span",
                                    { staticClass: "fee-table__currency" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.assetIcon(fee.fee_asset))
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "fee-table__value text_medium" },
                                [_vm._v(_vm._s(_vm.i18n.c(fee.percent)) + "%")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "fee-table__value text_medium" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.i18n.c(fee.lower_bound)) + " "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "fee-table__currency" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetIcon(_vm.feesNames[asset])
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-cell",
                                { staticClass: "fee-table__value text_medium" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.i18n.c(fee.upper_bound)) + " "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "fee-table__currency" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assetIcon(_vm.feesNames[asset])
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ])
          })
        : _c("md-card-content", [
            _vm._v("\n    " + _vm._s(_vm.i18n.lbl_loading()) + "\n  ")
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d4ae864", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4ae864","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/fee/index/Fee.Index.vue
// module id = 7Chh
// module chunks = 1